<template>

  <main id="content" role="main" class="bg-light">

    <button type="button" class="btn btn-primary m-4" @click="get_pdf">Télécharger le PDF</button>
    <a class="btn btn-primary my-3 ml-2" href="https://partenaires.yvelines.fr/Extranet/extranet/login">Allez au portail</a>

    <div id="content-to-print">
      <div class="bg-primary">
        <div class="container">
          <h2 class="text-white py-3">Structure</h2>
        </div>
      </div>
      <div class="container space-1">
        <div class="card p-4">
          <div class="card-body">
            <div class="row align-items-center">
              <img class="img-thumbnail" :src="aap.logo_structure || '/modules/dlnkaap/img/socialmedia.jpg'"
                   style="height: 150px; max-width: 50%;">
              <h3 class="text-primary font-weight-bold ml-3 mb-0">{{aap.nom}}</h3>
            </div>

            <div class="row mt-3">
              <div class="col-6" style="border-right: 4px solid #F2F7F9;">
                <h4>Statut juridique : <span class="font-italic text-muted">{{ aap.statut_juridique }}</span></h4>
                <h4>SIRET : <span class="font-italic text-muted">{{ aap.siret }}</span></h4>
                <h4>Date d'immatriculation : <span class="font-italic text-muted">{{ aap.date_immatriculation }}</span></h4>
                <h4><span class="font-italic text-muted">{{ aap.adresse }}</span></h4>
                <h4><span class="font-italic text-muted">{{ aap.code_postal }} {{ aap.ville }}</span></h4>
              </div>
              <div class="col-6 pl-3">
                <h4><span class="font-italic text-muted">{{ aap.telephone }}</span></h4>
                <h4>E-mail : <span class="font-italic text-muted">{{ aap.email}}</span></h4>
                <h4>E-mail pour les correspondances : <span class="font-italic text-muted">{{ aap.contact_email }}</span></h4>
                <h4>Site web : <span class="font-italic text-muted">{{ aap.site_web }}</span></h4>
                <h4>Taille de la structure :
                  <span class="font-italic text-muted">{{ aap.taille_structure }}</span></h4>
              </div>
            </div>
          </div>


          <div class="card-footer pb-0">
            <h4>Activités principales / Historique</h4>
            <p class="text-muted font-size-1">{{ aap.activite_principale }}</p>
          </div>
        </div>
      </div>

      <div class="html2pdf__page-break"></div>

      <div class="bg-primary">
        <div class="container">
          <h2 class="text-white py-3">Projet</h2>
        </div>
      </div>
      <div class="container space-1">
        <div class="card p-4 my-2">
          <div class="card-header p-0">
            <h3 class="text-primary font-weight-bold mb-3">Identité du porteur de projet</h3>
          </div>

          <div class="card-body">

            <div class="row align-items-center">
              <img class="img-thumbnail" :src="photo_porteur" style="height: 150px; max-width: 50%;">
              <h3 class="ml-3 mb-0">{{ aap.candidat_nom }}</h3>
            </div>

            <div class="row mt-3">
              <div class="col-6" style="border-right: 4px solid #F2F7F9;">
                <h4>Fonction : <span class="font-italic text-muted">{{ aap.candidat_fonction }}</span></h4>
                <h4>Service : <span class="font-italic text-muted">{{ aap.candidat_service }}</span></h4>
              </div>
              <div class="col-6 pl-3">
                <h4><span class="font-italic text-muted">{{ aap.candidat_telephone }}</span></h4>
                <h4><span class="font-italic text-muted">{{ aap.candidat_email }}</span></h4>
              </div>
            </div>
          </div>


          <div v-if="aap.actions_recentes" class="card-footer pb-0">
            <h4 class="mb-3">Les projets des 2 dernières années</h4>
            <h5>Description</h5>
            <p class="text-muted font-size-1">
              {{ aap.actions_recentes_description}}
            </p>
            <h5>Financeurs</h5>
            <p class="text-muted font-size-1">
              {{ aap.financeur_recent}}
            </p>
            <h5 v-if="aap.coporte_recent">Expertise complémentaire</h5>
            <p class="text-muted font-size-1">
              {{ aap.coporte_recent_description }}
            </p>
          </div>
        </div>

        <div class="html2pdf__page-break"></div>

        <div class="card p-4 my-2">
          <div class="card-header p-0">
            <h3 class="text-primary font-weight-bold mb-3">Identité du projet</h3>
          </div>

          <div class="card-body">
            <div class="row mt-3">
              <h4 class="col-12">Nom du projet : <span class="text-primary">{{ aap.projet_nom }}</span></h4>
              <div class="col-6" style="border-right: 4px solid #F2F7F9;">
                <h4>Axe : <span class="font-italic text-muted">{{ aap.axe }}</span></h4>
                <h4>Dates du projet :
                  du <span class="font-italic text-muted">{{ aap.date_debut }}</span>&nbsp;
                  au <span class="font-italic text-muted">{{ aap.date_fin }}</span>
                </h4>
              </div>
              <div class="col-6 pl-3">
                <h4>Thématiques : </h4>
                <ul class="text-muted font-size-1">
                  <li v-for="tag in aap.tags">{{ tag.nom }}</li>
                </ul>
              </div>
            </div>


            <h4 class="mb-3">Les étapes du projet</h4>
            <div class="row">

              <div class="col-12 p-1" v-for="etape in aap.etapes" :key="etape.id">
                <div class="card bg-soft-primary p-2">
                  <h5>{{etape.etape }}</h5>
                  <p class="font-italic">{{ etape.date_french }}</p>
                  <p>
                    {{ etape.description }}
                  </p>
                </div>
              </div>

            </div>

            <h4 class="mt-2">Origine du projet</h4>
            <p class="text-muted font-size-1">
              {{ aap.origine }}
            </p>

            <h4>Présentation du projet</h4>
            <p class="text-muted font-size-1">
              {{ aap.presentation }}
            </p>
          </div>
        </div>

        <div class="html2pdf__page-break"></div>

        <div class="card p-4 my-2">
          <div class="card-header p-0">
            <h3 class="text-primary font-weight-bold mb-3">Déroulement du projet</h3>
          </div>

          <div class="card-body">
            <div class="row mt-3">
              <div class="col-12">
                <h4>Nombre d'évènements ponctuels : <span class="font-italic text-muted">{{ aap.evenements_ponctuel }}</span></h4>
                <h4>Nombre d'activités à l'année : <span class="font-italic text-muted">{{ aap.activites_annuelles }}</span></h4>
                <h4>Nombre d'ateliers par actvité : <span class="font-italic text-muted">{{ aap.ateliers_activite }}</span></h4>
              </div>
            </div>
            <h4 class="mt-3">Détail du programme</h4>
            <div class="row">

              <div class="col-12 p-1 align-items-stretch no-page-break" v-for="activite in aap.activites" :key="activite.id">
<!--                style="break-inside: avoid; break-after: page"-->
                <div class="card bg-soft-primary p-2">
                  <h5>{{ activite.activite }}</h5>
                  <p>
                    {{ activite.description }}
                  </p>
                </div>
              </div>

            </div>

            <h4 class="mt-3">Intervenants extérieurs <span class="text-muted">(si applicable)</span></h4>
            <div class="p-3">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th scope="col">Type d'intervenant</th>
                  <th scope="col">Nombre</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="intervenant in aap.intervenants">
                  <th scope="row">{{ intervenant.fonction }}</th>
                  <td>{{ intervenant.nombre }}</td>
                </tr>
                </tbody>
              </table>
            </div>


            <h4 class="mt-3">Moyens humains</h4>
            <div class="p-3">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th scope="col">Type de contrat</th>
                  <th scope="col">Nombre</th>
                  <th scope="col">Nombre d'ETP</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th scope="row">CDI</th>
                  <td>{{ aap.nombre_cdi }}</td>
                  <td>{{ aap.nombre_cdi_etp }}</td>
                </tr>
                <tr>
                  <th scope="row">CDD</th>
                  <td>{{ aap.nombre_cdd }}</td>
                  <td>{{ aap.nombre_cdd_etp }}</td>
                </tr>
                <tr>
                  <th scope="row">Statuts précaires</th>
                  <td>{{ aap.nombre_precaire }}</td>
                  <td>{{ aap.nombre_precaire_etp }}</td>
                </tr>
                <tr>
                  <th scope="row">Contrats aidés</th>
                  <td>{{ aap.nombre_contrat_aides }}</td>
                  <td>{{ aap.nombre_contrat_aides_etp }}</td>
                </tr>
                <tr>
                  <th scope="row">Bénévoles</th>
                  <td>{{ aap.nombre_benevoles }}</td>
                  <td>{{ aap.nombre_benevoles_etp }}</td>
                </tr>
                <tr>
                  <th scope="row">Fonctionnaires</th>
                  <td>{{ aap.nombre_fonctionnaires }}</td>
                  <td>{{ aap.nombre_fonctionnaires_etp }}</td>
                </tr>
                <tr>
                  <th scope="row">Autres</th>
                  <td>{{ aap.nombre_autres }}</td>
                  <td>{{ aap.nombre_autres_etp }}</td>
                </tr>
                </tbody>
              </table>
              <h4>Total : <span class="font-italic text-muted">{{ aap.total_humain}}</span></h4>
              <h4>Total ETP : <span class="font-italic text-muted">{{ aap.total_etp }}</span></h4>
            </div>
          </div>
        </div>

        <div class="html2pdf__page-break"></div>

        <div class="card p-4 my-2">
          <div class="card-header p-0">
            <h3 class="text-primary font-weight-bold mb-3">Objectifs du projet</h3>
          </div>

          <div class="card-body">
            <h4>Objectif global</h4>
            <p class="text-muted font-size-1">
              {{ aap.projet_objectif }}
            </p>


            <h4 class="mb-3">Objectifs opérationnels</h4>
            <div class="row">

              <div class="col-12 p-1" v-for="objectif in aap.objectifs">
                <div class="card bg-soft-primary p-2">
                  <h5>{{ objectif.objectif }}</h5>
                  <h6>Description</h6>
                  <p>
                    {{ objectif.description }}
                  </p>
                  <h6>Risques</h6>
                  <p>
                    {{ objectif.risque }}
                  </p>
                </div>
              </div>

            </div>

            <h4 class="mt-2">Communes du projet</h4>

            <div class="row">
              <div class="col-4">
                <ul class="text-muted font-size-1">
                  <li v-for="commune in aap.communes" :key="commune.id">{{ commune.nom }}</li>
                </ul>
              </div>
            </div>

            <h4 class="mt-2">Quartiers prioritaires concernés</h4>

            <div class="row">
              <div class="col-12">
                <ul class="text-muted font-size-1">
                  <li v-for="quartier in aap.quartiers">{{ quartier.nom }}</li>
                </ul>
              </div>
            </div>

            <h4>Résultats attendus</h4>
            <div class="col-12 ml-2">


              <h5>Indicateurs d'activité</h5>
              <div class="row">
                <div class="col-12 p-1 align-items-stretch" v-for="indicateur in aap.indicateurs" :key="indicateur.id">
                  <div class="card bg-soft-primary p-2">
                    <p>
                      {{ indicateur.indicateur }}
                    </p>
                  </div>
                </div>
              </div>

              <h5>Indicateurs de résultats</h5>
              <div class="row">
                <div class="col-12 p-1 align-items-stretch" v-for="indicateur in aap.indicateur_resultats" :key="indicateur.id">
                  <div class="card bg-soft-primary p-2">
                    <p>
                      {{ indicateur.indicateur }}
                    </p>
                  </div>
                </div>
              </div>


<!--              <h5>Unités de mesure</h5>-->
<!--              <p class="text-muted font-size-1">-->
<!--                {{ aap.unites_mesure }}-->
<!--              </p>-->

<!--              <h5>Résultats trimestriels estimés</h5>-->
<!--              <p class="text-muted font-size-1">-->
<!--                {{ aap.resultats_trimestriels_estimes }}-->
<!--              </p>-->

              <h5>Impact social du projet sur les bénéficiaires</h5>
              <p class="text-muted font-size-1">
                {{ aap.impact_social }}
              </p>
            </div>

            <h4>Public cible</h4>
            <div class="p-3">
              <table class="table table-striped table-bordered">
                <thead class="">
                <tr>
                  <th class="text-center" scope="col" style="width: 14.3%">Genre \ Age</th>
                  <th class="text-center" scope="col" style="width: 14.3%">- de 3 ans</th>
                  <th class="text-center" scope="col" style="width: 14.3%">4-10</th>
                  <th class="text-center" scope="col" style="width: 14.3%">11-17</th>
                  <th class="text-center" scope="col" style="width: 14.3%">18-24</th>
                  <th class="text-center" scope="col" style="width: 14.3%">25-65</th>
                  <th class="text-center" scope="col" style="width: 14.3%">+ de 65 ans</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th scope="row">Femmes</th>
                  <td class="text-center">{{ aap.femmes_tranche_1 }}</td>
                  <td class="text-center">{{ aap.femmes_tranche_2 }}</td>
                  <td class="text-center">{{ aap.femmes_tranche_3 }}</td>
                  <td class="text-center">{{ aap.femmes_tranche_4 }}</td>
                  <td class="text-center">{{ aap.femmes_tranche_5 }}</td>
                  <td class="text-center">{{ aap.femmes_tranche_6 }}</td>
                </tr>
                <tr>
                  <th scope="row">Hommes</th>
                  <td class="text-center">{{ aap.hommes_tranche_1 }}</td>
                  <td class="text-center">{{ aap.hommes_tranche_2 }}</td>
                  <td class="text-center">{{ aap.hommes_tranche_3 }}</td>
                  <td class="text-center">{{ aap.hommes_tranche_4 }}</td>
                  <td class="text-center">{{ aap.hommes_tranche_5 }}</td>
                  <td class="text-center">{{ aap.hommes_tranche_6 }}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="ml-3">
              <h5 class="mt-2">Typologie public</h5>

              <div class="row">
                <div class="col-6">
                  <ul class="text-muted font-size-1">
                    <li v-for="pub in aap.publics" :key="pub.id">{{ pub.nom }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="html2pdf__page-break"></div>

        <div class="card p-4 my-2">
          <div class="card-header p-0">
            <h3 class="text-primary font-weight-bold mb-3">Budget</h3>
          </div>

          <div class="card-body">

            <h3 class="text-center">Montant global du projet : <span class="font-italic text-muted">{{ aap.budget_global }} € HT</span></h3>
            <h3 class="text-center">Montant de la subvention sollicitée : <span class="font-italic text-muted">{{ aap.subvention_sollicitee }} € HT</span></h3>


            <hr class="my-4">

            <h4 class="mb-3">Besoins en bénévoles et missions <span class="font-italic text-muted">(si applicable)</span></h4>
            <div class="row">
              <div class="col-12 p-1" v-for="(benevole, index) in aap.benevoles_projet">
                <div class="card bg-soft-primary p-2">
                  <h5>Mission #{{ index + 1 }}</h5>
                  <p>Nombre de bénévoles sollicités : <span class="font-italic text-muted">{{ benevole.nombre }}</span></p>
                  <p>{{ benevole.mission }}</p>
                </div>
              </div>
            </div>

            <div v-if="aap.besoins_materiels">
              <h4 class="my-3">Besoins en matériel <span class="font-italic text-muted">(si applicable)</span></h4>
              <p class="text-muted font-size-1">
                {{ aap.materiels }}
              </p>
            </div>


            <div v-if="aap.besoins_locaux">
              <h4 class="mb-3">Besoins en locaux <span class="font-italic text-muted">(si applicable)</span></h4>
              <p class="text-muted font-size-1">
                {{ aap.locaux }}
              </p>
            </div>

            <h4 class="mb-3">Informations complémentaires</h4>
            <p class="text-muted font-size-1">
              {{ aap.infos_complementaires }}
            </p>
          </div>
        </div>
      </div>

      <div class="html2pdf__page-break"></div>

      <div class="container space-1">
        <div class="card card-body">

          <span class="text-danger h3">Finalisez votre demande de subvention :</span>

          <p>
            Postez :
          </p>
          <ul>
            <li>
              votre candidature <button type="button" class="btn btn-sm btn-primary mx-1" @click="get_pdf">(candidature pdf)</button>
            </li>
            <li>
              Votre budget<a class="btn btn-primary btn-sm my-2 mx-1" href="/modules/dlnkaap/files/budget.xlsx" download>(budget)</a>
            </li>
            <li>
              Postez-les sur <a class="btn btn-sm btn-primary mx-1" href="https://partenaires.yvelines.fr/Extranet/extranet/login">le portail des Yvelines</a>
            </li>

          </ul>

          <p>
            Vous serez informé(e) de l'avancement de vos projets sur ZeLink ainsi que par mail.
            <br>
            A très bientôt pour le suivi de vos demandes!
          </p>

        </div>
      </div>

    </div>

  </main>

</template>



<script>

export default {
  props: ['aap_id'],
  data: function () {
    return {
      message: "",
      message_type: "",

      customer: Object,
      aap: Object,
      logo_structure: String,
      photo_porteur: String,
      projet_illustration: String,
    }
  },
  mounted() {
    this.logo_structure = "/modules/dlnkaap/img/socialmedia.jpg"
    this.photo_porteur = "/modules/dlnkaap/img/socialmedia.jpg"
    this.projet_illustration = "/modules/dlnkaap/img/socialmedia.jpg"
    this.get_data()

  },

  computed: {},

  watch: {
  },

  methods: {

    close_message: function () {
      this.message = null;
    },

    get_pdf: function () {
      let element = document.getElementById('content-to-print');
      let opt = {
        // margin:       0,
        margin: {top: 1, right: 0, bottom: 0, left: 0},
        enableLinks:  true,
        filename:     'candidature.pdf',
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2 },
        pagebreak:    { mode: ['avoid-all', 'legacy'] },
        // pagebreak:    { after: '.no-page-break'}, // , avoid: '.no-page-break'
        jsPDF:        { unit: 'in', format: 'a4', orientation: 'portrait' }
      };

      html2pdf(element, opt);
    },

    get_data: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += `aaps/${_this.aap_id}.json`
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.aap = response.data.aap

            if (typeof(response.data.logo_structure) != 'undefined' ) {
              _this.logo_structure = response.data.logo_structure
            }

            if (typeof(response.data.photo_porteur) != 'undefined' ) {
              _this.photo_porteur = response.data.photo_porteur
            }
            //
            // if (typeof(response.data.projet_illustration) != 'undefined' ) {
            //   _this.projet_illustration = response.data.projet_illustration
            // } else {
            //   _this.projet_illustration = "/modules/dlnkaap/img/socialmedia.jpg"
            // }

          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );

    },
  }
}
</script>
